import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetPoolOptions } from '../../../../Tables/Settings/PlanUnits/components/utils/useGetPoolOptions';
import { toOptions } from 'utils/toOptions';

import {
  useGetClusters,
  useGetContracts,
  useGetCostCentersWithGivenInterval,
  useGetEmployees
} from '../../../../../../queries';
import {
  ControlledCheckbox,
  ControlledCheckboxAutoComplete,
  ControlledSelect
} from '../../../../../shared';
import ValidFromAndToSection from './ValidFromAndToSection';
import { Box } from '@mui/material';
import { onRemoveElement } from '../utils/onRemoveElement';

const DutyLineExtSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, setValue, getValues, watch } = useFormContext();
  const { data: contracts } = useGetContracts();
  const { data: pools } = useGetPoolOptions();
  const { data: clusters } = useGetClusters();
  const { data: employees } = useGetEmployees();
  const { data: costCenters } = useGetCostCentersWithGivenInterval(
    getValues('valid_from'),
    getValues('valid_to')
  );

  return (
    <>
      <ValidFromAndToSection />
      <Box>
        <ControlledCheckboxAutoComplete
          fullWidth
          name="br_id_list"
          label={t('customerCostCenter')}
          variant="outlined"
          options={costCenters ?? []}
          control={control}
          idProperty="value"
          labelProperty="label"
          allowItemRemoval
          onRemoveElement={(id) =>
            onRemoveElement(setValue, watch, 'br_id_list', id)
          }
        />
      </Box>
      <Box>
        <ControlledCheckboxAutoComplete
          fullWidth
          name="emp_br_id_list"
          label={t('sourceCostCenter')}
          variant="outlined"
          options={costCenters ?? []}
          control={control}
          idProperty="value"
          labelProperty="label"
          allowItemRemoval
          onRemoveElement={(id) =>
            onRemoveElement(setValue, watch, 'emp_br_id_list', id)
          }
        />
      </Box>
      <ControlledSelect
        variant="outlined"
        control={control}
        name="emp_id_list"
        label={t('employees')}
        options={employees ?? []}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cluster_list"
        label={t('cluster')}
        options={toOptions(clusters ?? [], 'clusterId', 'name')}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="pool_list"
        label={t('pool')}
        options={pools}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="contract_list"
        label={t('contract')}
        options={contracts ?? []}
      />
      <ControlledCheckbox
        control={control}
        name="not_ready_for_realisation_flag"
        label={t('notReadyForRealisation')}
      />
      <ControlledCheckbox
        control={control}
        name="dub_trv_flag"
        label={t('onlyDouble')}
      />
    </>
  );
};

export default DutyLineExtSection;
